import React from "react";
import Dropdown from 'react-bootstrap/Dropdown';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightFromBracket, faKey } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from "../../contexts/AuthContext";

function TopNav() {
  const { logout, userDetail, role } = useAuth();
  const navigate = useNavigate();

  const changePasswordPath =
    role === "Community" ? "/community-portal/change-password" : "/admin/change-password";

  return (
    <div className="top-bar">
      <div className="dropdown float-end">
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic">
          {userDetail?.name?.replace(/\b\w/g, char => char.toUpperCase())}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => navigate(changePasswordPath)}>
              <FontAwesomeIcon className="px-2" icon={faKey} />Change Password
            </Dropdown.Item>
            <Dropdown.Item onClick={logout}><FontAwesomeIcon className="px-2" icon={faArrowRightFromBracket} />Logout</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}

export default TopNav;
